export default "__VITE_ASSET__e8960c3c__"